<template>
  <div class="ligin">
    <div class="ligintop">
      <div class="title">上海唐赢科技有限公司掌大师系统隐私政策</div>
      <div class="content">
        <h3>
一、尊敬的用户，掌大师隐私政策于2022年3月29日正式更新，请您知晓，我们收集信息的方式、范围和目的
        </h3>
        <h3>
（一）我们将通过以下途径收集和获得您的信息：
        </h3>
        <h3>
1、您提供的信息。 例如：
        </h3>
        <h3>
（1）您在注册掌大师服务的账号或使用掌大师服务时，向我们提供的信息；
        </h3>
        <h3>
（2）您通过掌大师服务向其他方提供的共享信息，以及您使用掌大师服务时所储存的信息。
        </h3>
        <h3>
2、其他方分享的您的信息。亦即其他方使用掌大师服务时所提供有关您的共享信息。
        </h3>
        <h3>
3、我们获取的您的信息。您在使用掌大师服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。
        </h3>
        <h3>
4、我们通过COOKIES和WEB BEACON获取的信息。我们和第三方合作伙伴可能通过COOKIES和WEBBEACON收集和使用您的信息，并将该等信息储存。
        </h3>
        <h3>
5、掌大师系统有和第三方合作的功能,您在使用掌大师的系统时，掌大师通过软件系统获取您的软件安装列表信息,以便于功能的使用。   
        </h3>
        <h3>
（二）我们会出于以下目的，收集和使用您的信息：
        </h3>
        <h3>
 扫描二维码   参与活动、登录账号   相机     
         </h3>
        <h3>
 储存、分享   帮助用户储存、分享精彩瞬间    存储卡中的内容  
         </h3>
        <h3>
 更新软件     下载apk更新   存储卡中的内容
         </h3>
        <h3>
 实名注册账号   完成实名认证  身份证件号码、姓名
         </h3>
        <h3>
 账号登录及找回 读取设备识别码，提升账号易用性   设备唯一识别码
         </h3>
        <h3>
 手机号       验证本机号码   本机手机号
        </h3>
        <h3>
请留意：
        </h3>
        <h3>
（三）根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：
        </h3>
        <h3>
（1）与国家安全、国防安全有关的；
        </h3>
        <h3>
（2）与公共安全、公共卫生、重大公共利益有关的；
        </h3>
        <h3>
（3）与犯罪侦查、起诉、审判和判决执行等有关的；
        </h3>
        <h3>
（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </h3>
        <h3>
（5）所收集的信息是您自行向社会公众公开的；
        </h3>
        <h3>
（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
        </h3>
        <h3>
（7）根据您的要求签订合同所必需的；
        </h3>
        <h3>
（8）用于维护掌大师服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </h3>
        <h3>
（9）为合法的新闻报道所必需的；
        </h3>
        <h3>
（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
        </h3>
        <h3>
（11）法律法规规定的其他情形。
        </h3>
        <h3>    
二隐私及适用范围
        </h3>
        <h3>
掌大师进销存将仅根据本公司的隐私声明使用“您的资料”。本公司隐私声明的全
部条款属于本协议的一部份，因此，您必须仔细阅读。
        </h3>
        <h3>
        <h3>
(a)) 我们在系统中集成了第三方工具：com.huawei.hms(华为;华为推送) com.alipay(支付宝;阿里乘车码;阿里芝麻信用实名认证;芝麻认证) cn.jpush.android(极光;极光推送)。com.tencent.mm.opensdk:wechat-sdk-android-with-mta:+   微信的，支付或者登录、分享之类
        </h3>                
        <h3>
(b) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
        </h3>
        <h3>
(c) 本应用通过合法途径从商业伙伴处取得的用户个人数据。
        </h3>
        <h3>
(d) 我们的产品基于DCloud app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息）,设备MAC地址和软件安装列表、通讯录和短信,以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能
和用户体验，为用户提供更好的服务
        </h3>
        <h3>
三. 信息使用
        </h3>
        <h3>
(a)本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
        </h3>
        <h3>
(b) 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
        </h3>
        <h3>
(c) 为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
        </h3>
        <h3>
(d) 我们最终您的选择权，摄像头，麦克，相册均不会默认开启，只有经过你授权才会打开。
        </h3>
(e) 在您注册本应用帐号时，您根据本应用要求提供的个人注册信息；
        </h3>        
        <h3>
四.终止或访问限制
        </h3>
        <h3>
您同意，在掌大师进销存未向您收费的情况下，掌大师进销存可自行全权决定以任何理由(包括但不限于掌大师进销
存认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事，或您在超过90天的
时间内未以您的账号及密码登录网站)终止您的“服务”密码、账户(或其任何部份)或您对“服务”的使用，并删除和丢
弃您在使用“服务”中提交的“您的资料”。您同意，在掌大师进销存向您收费的情况下，掌大师进销存应基于合理的怀
疑且经电子邮件通知的情况下实施上述终止服务的行为。掌大师进销存同时可自行全权决定，在发出通知或不发出
通知的情况下，随时停止提供“服务”或其任何部份。您同意，根据本协议的任何规定终止您使用“服务”之措施可在不
发出事先通知的情况下实施，并承认和同意，掌大师进销存可立即使您的账户无效，或撤销您的账户以及在您的账
户内的所有相关资料和档案，和/或禁止您进一步接入该等档案或“服务”。账号终止后，掌大师进销存没有义务为您
保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，掌大师进
销存不会就终止您接入“服务”而对您或任何第三者承担任何责任。
        </h3>
        <h3>
五. 信息存储和交换
        </h3>
        <h3>
本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。
        </h3>
        <h3>
六.违反规则会有什么后果
        </h3>
        <h3>
在不限制其他补救措施的前提下，发生下述任一情况，本公司可立即发出警告，暂时中止、永久中止或终止您的会
员资格，删除您的任何现有数据信息，以及您在网站上展示的任何其他资料：您违反本协议；本公司无法核实
或鉴定您向本公司提供的任何资料；或本公司相信您的行为可能会使您、本公司用户或通过本公司或本公司网
站提供服务的第三者服务供应商发生任何法律责任。在不限制任何其他补救措施的前提下，倘若发现您从事涉及本
公司网站的诈骗活动，掌大师进销存可暂停或终止您的账户。
        </h3>
        <h3>  
七.服务
        </h3>
        <h3>
“按现状”提供本公司会尽一切努力使您在使用掌大师进销存的过程中得到乐趣。遗憾的是，本公司不能随时预见到任何技术上的
问题或其他困难。该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用“服务”的风险由
您自行承担。“服务”以“按现状”和“按可得到”的基础提供。掌大师进销存明确声明不作出任何种类的所有明示或暗示
的保证，包括但不限于关于适销性、适用于某一特定用途和无侵权行为等方面的保证。掌大师进销存对下述内容不
作保证：“服务”会符合您的要求；“服务”不会中断，且适时、安全和不带任何错误；通过使用“服务”而可能获
取的结果将是准确或可信赖的；及您通过“服务”而购买或获取的任何产品、服务、资料或其他材料的质量将符合
您的预期。通过使用“服务”而下载或以其他形式获取任何材料是由您自行全权决定进行的，且与此有关的风险由您自
行承担，对于因您下载任何该等材料而发生的您的电脑系统的任何损毁或任何数据损失，您将自行承担责任。您从
掌大师进销存或通过或从“服务”获取的任何口头或书面意见或资料，均不产生未在本协议内明确载明的任何保证。
        </h3>
        <h3>   
八.责任范围
        </h3>
        <h3>
您明确理解和同意，掌大师进销存不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限于利润、商
誉、使用、数据等方面的损失或其他无形损失的损害赔偿(无论掌大师进销存是否已被告知该等损害赔偿的可能
性)：使用或未能使用“服务”；因通过或从“服务”购买或获取任何货物、样品、数据、资料或服务，或通过或
从“服务”接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用；未经批准接入或更改您的传输资料
或数据；任何第三者对“服务”的声明或关于“服务”的行为；或因任何原因而引起的与“服务”有关的任何其他事
宜，包括疏忽。
        </h3>
        <h3>
九.账号注销
        </h3>
        <h3>
当您的账号不在使用后，您可以在APP中，店铺界面，进入我的，点击头像，进入到账号注销操作。您申请注销后，
我们的工作人员会在15个工作日内审批后，完成您的账号注销。
        </h3>            
      </div>
    </div>
  </div>
  
</template>
<script>
import { Button, Row, Col, Field, Cell, CellGroup ,Checkbox, CheckboxGroup,Image,Card,Toast } from "vant";
export default {
  name: "principalLogin",
  components: {
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Checkbox.name]:Checkbox,
    [CheckboxGroup.name]:CheckboxGroup,
    [Image.name]:Image,
    [Card.name]:Card,
    [Toast.name]:Toast
  },
  data() {
    return {    
        account:"",
        password:"",
        phone:"",
        openid:""
    };
  },
  methods :{

  },
  created(){
    // if (sessionStorage.principal) {
    //   this.$router.push({path:"/createQrcode",query:{phone:JSON.parse(sessionStorage.principal.cellPhone)}});
    // }
  }
};
</script>
<style scoped>
.ligin{
  width: 100%;
  height: 100%;
  background: #feffff;
  position: relative;

}
.ligin .ligintop{
  width: 100%;
	height: 1rem;
  position: relative;
}
.title{
  width: 100%;
  font-size: 0.4rem;color: #110f0f; display: inline-block; 
  text-align: center; 
}
.content{
  width: 100%;
  font-size: 0.3rem;color: #110f0f; display: inline-block; 
}
</style>
